// src/pages/RestaurantPOS/manager/LoungeManagerDashboard.jsx
import React from 'react';
import ManagerDashboard from './ManagerDashboard';

const LoungeManagerDashboard = () => {
  return <ManagerDashboard locationKey="lounge" />;
};

export default LoungeManagerDashboard;